import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import VerifyEmail from './components/VerifyEmail';
const verifyemail = (props,{ t }) => (
  <Container  >
    <VerifyEmail  {...props} />
  </Container>
);

verifyemail.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(verifyemail);
